import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from 'features/app/store/store';
import { DialPadVariant } from 'features/dial-pad/enums';
import type { DialPadState } from 'features/dial-pad/interfaces';

export const initialDialPadState: DialPadState = {
  isDialPadOpened: false,
  dialPadVariant: DialPadVariant.PHONE_DEALER,
  dialedNumber: '',
  showInputToConsumer: false,
  autoLaunchDialPad: false,
  isCollapsed: true,
};

const dialPadSlice = createSlice({
  name: 'dial-pad',
  initialState: initialDialPadState,
  reducers: {
    toggleDialPad: (state) => {
      state.isDialPadOpened = !state.isDialPadOpened;
    },
    setDialPadVariant: (state, action: PayloadAction<DialPadVariant>) => {
      state.dialPadVariant = action.payload;
    },
    clearAndCloseDialPad: (state) => {
      state.dialedNumber = '';
      state.isDialPadOpened = false;
    },
    appendDialedNumberToState: (state, action: PayloadAction<string>) => {
      state.dialedNumber = state.dialedNumber + action.payload;
    },
    clearDialedNumber: (state) => {
      state.dialedNumber = '';
    },
    toggleShowInputToConsumer: (state) => {
      state.showInputToConsumer = !state.showInputToConsumer;
    },
    setAutoLaunchDialPad: (state, action: PayloadAction<boolean>) => {
      state.autoLaunchDialPad = action.payload;
    },
    toggleDialPadCollapse: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },
    resetDialPad: (state) => {
      return {
        ...initialDialPadState,
        autoLaunchDialPad: state.autoLaunchDialPad,
      };
    },
  },
});

export const {
  toggleDialPad,
  resetDialPad,
  setDialPadVariant,
  clearAndCloseDialPad,
  appendDialedNumberToState,
  clearDialedNumber,
  toggleShowInputToConsumer,
  setAutoLaunchDialPad,
  toggleDialPadCollapse,
} = dialPadSlice.actions;

export const isDialPadOpenedSelector = ({ dialPad }: RootState) =>
  dialPad.isDialPadOpened;

export const autoLaunchDialPadSelector = ({ dialPad }: RootState) =>
  dialPad.autoLaunchDialPad;

export const dialPadVariantSelector = ({ dialPad }: RootState) =>
  dialPad.dialPadVariant;

export const selectDialedNumberOnNumberPad = ({ dialPad }: RootState) =>
  dialPad.dialedNumber;

export const selectShowInputToConsumer = ({ dialPad }: RootState) =>
  dialPad.showInputToConsumer;

export const selectIsDialPadCollapsed = ({ dialPad }: RootState) =>
  dialPad.isCollapsed;

export const dialPadReducer = dialPadSlice.reducer;
